import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-566e3050"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "kt_app_header",
  class: "app-header"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15"
}
const _hoisted_3 = {
  key: 0,
  alt: "Logo",
  src: "/logo.png",
  class: "h-20px h-lg-30px app-sidebar-logo-default"
}
const _hoisted_4 = {
  key: 1,
  alt: "Logo",
  src: "/logo-dark.png",
  class: "h-30px h-lg-40px app-sidebar-logo-default"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center d-lg-none ms-n2 me-2",
  title: "Show sidebar menu"
}, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0 pe-5 me-5" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "mb-0 mt-0 ms-5 d-none d-md-block mt-1 header-title" }
const _hoisted_9 = {
  key: 0,
  class: "mb-0 mt-0 mt-md-2 mb-0 ms-5 fw-normal header-subtitle"
}
const _hoisted_10 = {
  class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1",
  id: "kt_app_header_wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTHeaderMenu = _resolveComponent("KTHeaderMenu")!
  const _component_KTHeaderNavbar = _resolveComponent("KTHeaderNavbar")!

  return (_ctx.headerDisplay)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["app-container d-flex align-items-stretch justify-content-between", {
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }])
        }, [
          (_ctx.layout === 'light-header' || _ctx.layout === 'dark-header')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_router_link, {
                  to: _ctx.user.userType === 'admissible' ? '/espace-admissible' : '/'
                }, {
                  default: _withCtx(() => [
                    (_ctx.themeMode === 'light' && _ctx.layout === 'light-header')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                      : _createCommentVNode("", true),
                    (
              _ctx.layout === 'dark-header' ||
              (_ctx.themeMode === 'dark' && _ctx.layout === 'light-header')
            )
                      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('global.title')), 1),
              (_ctx.admissibleInfos?.formationYear && _ctx.admissibleInfos?.formationLibelle)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_ctx.admissibleInfos.admLastName) + " " + _toDisplayString(_ctx.admissibleInfos.admFirstName) + " - Rentrée " + _toDisplayString(_ctx.admissibleInfos.formationYear) + "/" + _toDisplayString(_ctx.admissibleInfos.formationYear + 1) + " - A" + _toDisplayString(_ctx.admissibleInfos.formationEtape) + " " + _toDisplayString(_ctx.admissibleInfos.formationLibelle), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_KTHeaderMenu),
            _createVNode(_component_KTHeaderNavbar)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}